// Format dată RO standard: dd/mm/yyyy
// Acceptă fie ISO "YYYY-MM-DD" (date pure) fie ISO datetime "YYYY-MM-DDTHH:mm:ss(.sss)Z"
// Returnează stringul gol pentru null/undefined/empty.
export function fmtRoDate(value, fallback = "") {
  if (!value) return fallback;
  const s = String(value).trim();
  if (!s) return fallback;
  // Pattern simplu YYYY-MM-DD
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  // Datetime ISO: ia doar prima parte
  const m2 = s.match(/^(\d{4})-(\d{2})-(\d{2})[T ]/);
  if (m2) return `${m2[3]}/${m2[2]}/${m2[1]}`;
  // Fallback prin Date()
  try {
    const d = new Date(s);
    if (isNaN(d.getTime())) return fallback || s;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${d.getFullYear()}`;
  } catch {
    return fallback || s;
  }
}

// Format dată+oră RO: dd/mm/yyyy HH:mm
export function fmtRoDateTime(value, fallback = "") {
  if (!value) return fallback;
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return fallback || String(value);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const HH = String(d.getHours()).padStart(2, "0");
    const MM = String(d.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${d.getFullYear()} ${HH}:${MM}`;
  } catch {
    return fallback || String(value);
  }
}
